var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-menu",
    {
      attrs: {
        left: "",
        "close-on-content-click": false,
        "content-class": "white",
        disabled: true /*purchaseOption.name !== 'Assessment 30' || !can('Override attendance')*/,
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              _c(
                "v-chip",
                _vm._g(
                  _vm._b(
                    {
                      staticClass: "pl-0 pr-1",
                      attrs: { small: "", outlined: "" },
                    },
                    "v-chip",
                    attrs,
                    false
                  ),
                  on
                ),
                [
                  _c(
                    "div",
                    { class: ["align-center justify-start flex mr-1"] },
                    [
                      _c(
                        "v-list-item-avatar",
                        {
                          class: [
                            _vm.getStatus(_vm.purchaseOption).color,
                            "mx-0",
                          ],
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "white--text font-weight-bold" },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.getStatus(_vm.purchaseOption).title
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "soli-grey caption" }, [
                    _vm._v(_vm._s(_vm.purchaseOption.name)),
                  ]),
                ]
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.menu,
        callback: function ($$v) {
          _vm.menu = $$v
        },
        expression: "menu",
      },
    },
    [
      _vm._v(" "),
      _vm.apiLoading
        ? _c("v-skeleton-loader", {
            staticClass: "mx-auto",
            attrs: { type: "list-item" },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.apiLoading
        ? _c(
            "v-list",
            _vm._l(_vm.otherOptions, function (option) {
              return _c(
                "v-list-item",
                {
                  key: option.id,
                  class: [
                    "soli-round",
                    _vm.purchaseOption.id == option.id
                      ? "soli-status-blue"
                      : null,
                  ],
                  attrs: { disabled: _vm.is("Admin") ? false : !option.paid },
                  on: {
                    click: function ($event) {
                      _vm.newOption = option
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { class: ["align-center justify-start flex mr-3"] },
                    [
                      _c(
                        "v-list-item-avatar",
                        { class: [_vm.getStatus(option).color, "mx-0"] },
                        [
                          _c(
                            "div",
                            { staticClass: "white--text font-weight-bold" },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.getStatus(option).title) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "caption",
                      class: {
                        "white--text": _vm.purchaseOption.id == option.id,
                        "soli-grey": option.paid,
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(option.name) +
                          "\n            "
                      ),
                    ]
                  ),
                ]
              )
            }),
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }